export default __webpack_public_path__ + "assets/img/company-award02.png";